module.exports = __webpack_public_path__ + "img/download_btn.2f8c2139.png";